<div class="modal-header bg-light">
  <h4 class="modal-title" class="text-center"><b>Expendedoras</b></h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
    
  </button>
</div>

<div class="modal-body">
<table *ngIf="this.aeroplantas!=null && this.aeroplantas.length > 0" class="table table-striped table-hover">
  <thead>
    <tr>
      <td class="text-center"><b>Código</b></td>
      <td class="text-center"><b>Nombre</b></td>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let a of aeroplantas; let i = index">
      <td class="text-center">{{  a.codigoExpendedora }}</td>
      <td class="text-center"> {{a.nombreExpendedora}}</td>
   </tr>
  </tbody>
</table>
</div>
